import { RegisterFormData } from '../types';

export const sanitizeOrganizationId = (value: string): string =>
  value.toLowerCase().replace(/\s+/g, '');

export const transformFormDataForSubmission = (
  values: RegisterFormData,
  isSubAccountEnabled?: boolean,
  organizationId?: string | null
): RegisterFormData => {
  const sanitizedValues = Object.fromEntries(
    Object.entries(values).map(([key, value]) => {
      if (typeof value === 'string') {
        return [key, value.trim()];
      }
      return [key, value];
    })
  ) as RegisterFormData;

  const finalPayload: RegisterFormData = { ...sanitizedValues };

  if (isSubAccountEnabled) {
    finalPayload.isSubaccount = true;

    const providerSource = organizationId || sanitizedValues.masterAccountName;

    if (providerSource) {
      finalPayload.providerCode = sanitizeOrganizationId(providerSource);
    }
  }

  delete finalPayload.masterAccountName;

  return finalPayload;
};
